export default __webpack_public_path__ + "assets/images/0c8fa093f442f32c10182575ae5355e5.svg";